import * as classnames from 'classnames'
import * as React from 'react'
import Slider, { Settings } from 'react-slick'

import { QuizType } from '../../../../../commons/EditorStatus'
import MobileEditorPreview from '../MobileEditorPreview/MobileEditorPreview'
import * as styles from './MobileEditorPreviewSlider.css'

interface MobileEditorPreviewSliderProps {
  questions: any[]
  eventTitle: string
  eventImage: string
  currentIndex: number
  handleChangeIndex: (index: number, type: number) => void
}

class MobileEditorPreviewSlider extends React.Component<MobileEditorPreviewSliderProps> {
  private slider: any

  constructor(props: any) {
    super(props)
    this.slider = React.createRef()
  }
  public slideTo(index: number) {
    if (this.slider) {
      this.slider.current.slickGoTo(index)
    }
  }

  public render() {
    const { questions, eventImage, eventTitle, handleChangeIndex, currentIndex } = this.props
    const settings: Settings = {
      dots: false,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
      centerMode: true,
      infinite: false,
      variableWidth: true,
      beforeChange: (_: number, newIndex: number) => {
        if (newIndex === 0) {
          handleChangeIndex(0, QuizType.FIRSTPAGE.value)
          return
        }
        if (newIndex === questions.length + 1) {
          handleChangeIndex(0, QuizType.RANKING.value)
          return
        }
        handleChangeIndex(newIndex - 1, QuizType.QUESTION.value)
      }
    }
    return (
      <Slider {...settings} ref={this.slider}>
        <div className={classnames({ [styles.previewItem]: true, [styles.nonactive]: currentIndex !== 0 })}>
          <MobileEditorPreview type={QuizType.FIRSTPAGE.value} eventTitle={eventTitle} eventImage={eventImage} />
        </div>
        {questions.map((question, index) => (
          <div
            key={question.id}
            className={classnames({ [styles.previewItem]: true, [styles.nonactive]: currentIndex !== index + 1 })}
          >
            <MobileEditorPreview question={question} index={index} type={QuizType.QUESTION.value} />
          </div>
        ))}
        <div
          className={classnames({
            [styles.previewItem]: true,
            [styles.nonactive]: currentIndex !== questions.length + 1
          })}
        >
          <MobileEditorPreview type={QuizType.RANKING.value} />
        </div>
      </Slider>
    )
  }
}

export default MobileEditorPreviewSlider
